import {IPopupManager} from '@mintdata/mint-kit/impl/components/popover/PopupTypes';
import {NonPassiveEventListeners} from '@mintdata/mint-kit/impl/events/Events';
import * as PropTypes from 'prop-types';

export interface IComponentContext
{
    popupManager:IPopupManager;
    nonPassiveEventListeners:NonPassiveEventListeners;
}

export const componentContextTypes = {
    popupManager: PropTypes.object,
    nonPassiveEventListeners: PropTypes.object
};
